import memoizeOne from 'memoize-one';

// The REAL scrollbar size
// memoizeOne because it's expensive and we only need to calculate this once
// the server render will always return 0 but don't need to worry about
// a hydration mismatch as the client calls render, not hydrate.
const getScrollbarSize = memoizeOne((): number => {
	if (document && document.body) {
		const scrollbarContainer = document.createElement('div');
		const { style } = scrollbarContainer;
		style.position = 'absolute';
		style.width = '100px';
		style.height = '100px';
		style.overflow = 'scroll';
		style.top = '-9999px';

		document.body.appendChild(scrollbarContainer);

		// Pick arbitrary axis, both should have the same bar size
		const scrollbarSize = scrollbarContainer.offsetWidth - scrollbarContainer.clientWidth;

		document.body.removeChild(scrollbarContainer);

		return scrollbarSize;
	}

	return 0;
});

export default getScrollbarSize;
